import React from "react";
import { UserManagementScreen } from "~/screens/admin/user-management";

export const UserManagementTab: React.FC = () => {
  return <UserManagementScreen />;
};

export default UserManagementTab;
